interface UpdateSearchParamsOptions {
  remove?: readonly string[];
  set?: Record<string, string | null | undefined>;
}

export const updateSearchParams = (
  search: string,
  { remove = [], set = {} }: UpdateSearchParamsOptions = {}
) => {
  const searchParams = new URLSearchParams(search);

  for (const key of remove) {
    searchParams.delete(key);
  }

  for (const [key, value] of Object.entries(set)) {
    if (value === null || value === undefined) {
      searchParams.delete(key);
      continue;
    }

    searchParams.set(key, value);
  }

  const nextSearch = searchParams.toString();
  return nextSearch ? `?${nextSearch}` : "";
};
